import React from 'react';
import useFeatureFlag, { FEATURE_FLAGS } from 'flags/useFeatureFlag';
import Route404 from 'App/Router/Route404';
import { UserMessage } from 'Assistant/Chatbot/types';
import { useLocation } from 'react-router';
import uuid from 'uuid';
import { isMSTeams } from 'utils/MSTeams';
import { Chatbot } from '../../components/Chatbot';
import { PageContainer } from './styles';

export const ChatbotPage = () => {
  const isChatBotEnabled = useFeatureFlag(FEATURE_FLAGS.ENABLE_CHATBOT);
  const { state: locationState } = useLocation<UserMessage>();

  const teamsURLParams = new URLSearchParams(location.search);
  let userMessage: UserMessage | undefined;

  if (isMSTeams()) {
    const content = teamsURLParams.get('content');

    userMessage = content
      ? {
          content,
          topic: teamsURLParams.get('topic'),
          starterId: teamsURLParams.get('starterId'),
          id: uuid.v4(),
          createdAt: new Date().toISOString(),
        }
      : undefined;
  } else {
    userMessage = locationState;
  }

  if (!isChatBotEnabled) {
    return <Route404 />;
  }

  return (
    <PageContainer>
      <Chatbot initialMessage={userMessage} />
    </PageContainer>
  );
};
